export default __webpack_public_path__ + "static/media/img-62.20c3847e.jpg";